var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruth = function SvgTruth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.413 8.675a6.047 6.047 0 1 1-12.094 0 6.047 6.047 0 0 1 12.094 0m1.586 0a7.633 7.633 0 0 1-9.905 7.29l-.014.024-3.778 6.36a1.25 1.25 0 0 1-1.693.443 1.21 1.21 0 0 1-.437-1.673l3.718-6.26a7.633 7.633 0 1 1 12.108-6.184",
    clipRule: "evenodd"
  })));
};
export default SvgTruth;